export default __webpack_public_path__ + "static/media/sent_sms.aeab16ad.svg";